import { render, staticRenderFns } from "./UploadResultHeader.vue?vue&type=template&id=7f42f5e0"
import script from "./UploadResultHeader.vue?vue&type=script&lang=js"
export * from "./UploadResultHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports